import React, { useState } from 'react';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox';
export var RATIOS;
(function (RATIOS) {
    RATIOS[RATIOS["16_9"] = 0.5625] = "16_9";
    RATIOS[RATIOS["4_3"] = 0.75] = "4_3";
})(RATIOS || (RATIOS = {}));
// [NOTE]: This may not be the cleanest way to do this, generally we want to do it all through styles
// so this might be revisited to make it simpler if possible
const DNAAspectRatio = (props) => {
    const { children, enabled = true, style, ratio } = props;
    const [dimensions, setDimensions] = useState();
    const dWidth = dimensions?.width ?? 0;
    const dHeight = dimensions?.height ?? 0;
    const targetHeight = (dWidth * ratio);
    const fitsVertical = dimensions?.height === 0
        ? true
        : targetHeight <= dHeight;
    const diff = 1 - (dHeight / targetHeight);
    // If we have enough vertical room, we can render our target height without issue
    const verticalFit = {
        height: targetHeight,
        // [NOTE]: Not a great way to center something, however required as we want to avoid using
        //  explicit height values (through height or flex = n)
        marginVertical: (dHeight - targetHeight) / 2,
    };
    // If we don't have enough vertical room, we have to add padding to decrease the width, thus decreasing the height to fit
    const horizontalScaleToFit = { paddingHorizontal: (diff * dWidth) / 2 };
    return (<DNABox fill onLayout={(e) => setDimensions(e.nativeEvent.layout)} style={[
        style,
        { width: '100%' },
        !dimensions ? { height: '100%' } : {},
    ]}>
      <DNABox fill style={enabled ? (fitsVertical ? verticalFit : horizontalScaleToFit) : {}}>
        {children}
      </DNABox>
    </DNABox>);
};
DNAAspectRatio.RATIOS = RATIOS;
export default DNAAspectRatio;
//# sourceMappingURL=DNAAspectRatio.js.map